// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ✅ Main Container */
.analysis-container {
    max-width: 85%;
    margin: 40px auto;
    padding: 30px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.15);
}

/* ✅ Page Title */
.analysis-container h2 {
    text-align: center;
    font-size: 26px;
    font-weight: bold;
    color: #333;
    margin-bottom: 30px;
    text-transform: uppercase;
}

/* ✅ Job Details Table */
.analysis-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
    font-size: 16px;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
}

.analysis-table td {
    padding: 12px;
    border-bottom: 1px solid #ddd;
}

/* ✅ Logs Section */
.logs-container {
    background-color: #282c34;
    color: #fff;
    padding: 15px;
    border-radius: 6px;
    font-size: 14px;
    overflow-x: auto;
    white-space: pre-wrap;
}

/* ✅ Responsive Design */
@media (max-width: 768px) {
    .analysis-container {
        width: 95%;
        padding: 20px;
    }

    .analysis-table {
        font-size: 14px;
    }
}

.styled-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
}

.styled-table th, .styled-table td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: left;
}

.styled-table th {
    background-color: #273d3b;
    color: white;
}

.styled-table tr:nth-child(even) {
    background-color: #f2f2f2;
}

/* Analysis storage panel (total size + remove, one row per analysis run folder) */
.analysis-storage-panel {
    margin-bottom: 20px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
}

.analysis-storage-row {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px 16px;
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;
}

.analysis-storage-row:first-child {
    border-top: none;
}

.analysis-storage-row .asr-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
    flex: 1 1 auto;
}

.analysis-storage-row .asr-name {
    font-weight: 600;
    color: #213a22;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.analysis-storage-row .asr-meta {
    font-size: 12px;
    color: #64748b;
}

.analysis-storage-row .asr-size {
    font-size: 13px;
    color: #334155;
    white-space: nowrap;
    flex: 0 0 auto;
}

.analysis-storage-row .asr-remove-btn {
    flex: 0 0 auto;
    background-color: #dc2626;
    color: #fff;
    border: none;
    padding: 8px 14px;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;
}

.analysis-storage-row .asr-remove-btn:hover {
    background-color: #b91c1c;
}

.analysis-storage-row .asr-remove-btn:disabled {
    background-color: #cbd5e1;
    cursor: not-allowed;
}

/* =========================
   SAFE OVERRIDES ONLY
========================= */

/* Ensure container exists and is centered */
.analyses-container {
  width: 85% !important;
  margin: 40px auto !important;
}

/* Strong row demarcation */
.job-summary-table tbody tr {
  border-bottom: 2px solid #e5e7eb !important;
}

/* Normalize ALL action buttons */
.view-details-button,
.log-button,
.results-toggle-button,
.report-toggle-button, 
.interpretation-button,
.launch-jupyter-button {
    min-width: 140px;
    height: 38px;
    font-size: 14px;
    border-radius: 6px;
    margin-right: 12px;
    cursor: pointer;
    font-weight: bold;
    border: none;
}


/* Explicitly style log button (this WAS missing before) */
/* 🔧 HARD RESET for Log button — remove embossed look */
.log-button {
  box-shadow: none !important;
  border: none !important;
  outline: none !important;
  appearance: none;
  -webkit-appearance: none;
  background-image: none !important;
  background: #6981ae;
  color:#fffefe
}

/* Optional: consistent press behavior */
.log-button:active {
  transform: translateY(1px);
  box-shadow: none !important;
}


.log-button:hover {
  background: #1f2937;
}

.html-report {
    background: white;
    padding: 20px;
    border-radius: 8px;
    border: 1px solid #ddd;
    margin-bottom: 30px;
    overflow-x: auto;
}

.interpretation-container {
    margin-top: 40px;
    padding: 20px;
    background: #fafafa;
    border-radius: 8px;
}

.download-selected-button {
    float: right;
    background: #213a22;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
}

.interpretation-button {
    background-color: #273d3b;
    color: #ddd;
}

.interpretation-button:hover {
    background-color: #2f4f4d;
}

.interpret-button:disabled {
    background-color: #999;
    cursor: not-allowed;
}

.spinner {
    width: 16px;
    height: 16px;
    border: 3px solid #fff;
    border-top: 3px solid transparent;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin: auto;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

/* "Pending" indicator in the Credits Charged column (light cell background). */
.charge-pending {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #6b7280;
    font-size: 13px;
    font-style: italic;
}
.charge-pending-spinner {
    width: 12px;
    height: 12px;
    border: 2px solid #cbd5e1;
    border-top: 2px solid #2563eb;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    flex: 0 0 auto;
}

.interpret-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    z-index: 9999;
}

.interpret-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    padding: 24px;
    border-radius: 8px;
    width: 500px;
    z-index: 10000;
}

.interpretation-button{
    background-color: #273d3b;
    border: none;
    color:#ddd
}

.launch-jupyter-button {
    background-color: #272a3d; /* deep indigo */
    color: #ddd;
}

.launch-jupyter-button:hover {
    background-color: #323657;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.4);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.spinner {
    width: 60px;
    height: 60px;
    border: 8px solid #ccc;
    border-top-color: #ff9800;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}


.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal {
  background: white;
  padding: 30px 40px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.3);
  text-align: center;
  max-width: 400px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ff9800; /* your CloudGenomics accent */
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 20px auto;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Compact icon buttons in the execution "Action" column (labels moved to tooltips). */
.icon-action {
  box-sizing: border-box;
  width: 40px !important;
  height: 32px !important;
  min-width: 40px !important;
  max-width: 40px !important;
  padding: 0 !important;
  margin: 0 3px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  vertical-align: middle;
}
.icon-action:disabled { opacity: 0.5; cursor: not-allowed; }

/* ---- Merged execution table: run name + inline run details, status icons, size ---- */
.analysis-table td.run-cell { min-width: 240px; vertical-align: top; }

.analysis-table th.col-credits,
.analysis-table td.col-credits { width: 72px; text-align: right; white-space: nowrap; }

.run-name { font-weight: 600; color: #213a22; word-break: break-all; }

.run-details-toggle {
  margin-top: 4px;
  background: none;
  border: none;
  padding: 0;
  color: #2563eb;
  font-size: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.run-details-toggle:hover { text-decoration: underline; }
.run-details-caret { display: inline-block; font-size: 9px; transition: transform 0.15s ease; }
.run-details-caret.open { transform: rotate(90deg); }

.run-details {
  margin-top: 6px;
  padding: 8px 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 12px;
  color: #475569;
  line-height: 1.6;
}
.run-details .rd-label { font-weight: 600; color: #334155; }

.status-cell { display: inline-flex; align-items: center; gap: 6px; white-space: nowrap; }
.status-icon { font-size: 13px; line-height: 1; }
`, "",{"version":3,"sources":["webpack://./src/css/AnalysisView.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA,wBAAwB;AACxB;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA,mBAAmB;AACnB;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,wBAAwB;AACxB;IACI;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kFAAkF;AAClF;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;2BAE2B;;AAE3B,4CAA4C;AAC5C;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA,2BAA2B;AAC3B;EACE,2CAA2C;AAC7C;;AAEA,iCAAiC;AACjC;;;;;;IAMI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;;AAGA,0DAA0D;AAC1D,wDAAwD;AACxD;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB;AACF;;AAEA,wCAAwC;AACxC;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA,+EAA+E;AAC/E;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ;AACJ;;AAEA;IACI,yBAAyB,EAAE,gBAAgB;IAC3C,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB,EAAE,8BAA8B;EACzD,kBAAkB;EAClB,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,sFAAsF;AACtF;EACE,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;AACA,wBAAwB,YAAY,EAAE,mBAAmB,EAAE;;AAE3D,wFAAwF;AACxF,8BAA8B,gBAAgB,EAAE,mBAAmB,EAAE;;AAErE;iCACiC,WAAW,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;;AAEtF,YAAY,gBAAgB,EAAE,cAAc,EAAE,qBAAqB,EAAE;;AAErE;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA,4BAA4B,0BAA0B,EAAE;AACxD,qBAAqB,qBAAqB,EAAE,cAAc,EAAE,gCAAgC,EAAE;AAC9F,0BAA0B,wBAAwB,EAAE;;AAEpD;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA,yBAAyB,gBAAgB,EAAE,cAAc,EAAE;;AAE3D,eAAe,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACzF,eAAe,eAAe,EAAE,cAAc,EAAE","sourcesContent":["/* ✅ Main Container */\n.analysis-container {\n    max-width: 85%;\n    margin: 40px auto;\n    padding: 30px;\n    background: #ffffff;\n    border-radius: 12px;\n    box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.15);\n}\n\n/* ✅ Page Title */\n.analysis-container h2 {\n    text-align: center;\n    font-size: 26px;\n    font-weight: bold;\n    color: #333;\n    margin-bottom: 30px;\n    text-transform: uppercase;\n}\n\n/* ✅ Job Details Table */\n.analysis-table {\n    width: 100%;\n    border-collapse: collapse;\n    text-align: left;\n    font-size: 16px;\n    background: #ffffff;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.analysis-table td {\n    padding: 12px;\n    border-bottom: 1px solid #ddd;\n}\n\n/* ✅ Logs Section */\n.logs-container {\n    background-color: #282c34;\n    color: #fff;\n    padding: 15px;\n    border-radius: 6px;\n    font-size: 14px;\n    overflow-x: auto;\n    white-space: pre-wrap;\n}\n\n/* ✅ Responsive Design */\n@media (max-width: 768px) {\n    .analysis-container {\n        width: 95%;\n        padding: 20px;\n    }\n\n    .analysis-table {\n        font-size: 14px;\n    }\n}\n\n.styled-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n}\n\n.styled-table th, .styled-table td {\n    border: 1px solid #ddd;\n    padding: 10px;\n    text-align: left;\n}\n\n.styled-table th {\n    background-color: #273d3b;\n    color: white;\n}\n\n.styled-table tr:nth-child(even) {\n    background-color: #f2f2f2;\n}\n\n/* Analysis storage panel (total size + remove, one row per analysis run folder) */\n.analysis-storage-panel {\n    margin-bottom: 20px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.analysis-storage-row {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 12px 16px;\n    background: #f8fafc;\n    border-top: 1px solid #e2e8f0;\n}\n\n.analysis-storage-row:first-child {\n    border-top: none;\n}\n\n.analysis-storage-row .asr-info {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    flex: 1 1 auto;\n}\n\n.analysis-storage-row .asr-name {\n    font-weight: 600;\n    color: #213a22;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.analysis-storage-row .asr-meta {\n    font-size: 12px;\n    color: #64748b;\n}\n\n.analysis-storage-row .asr-size {\n    font-size: 13px;\n    color: #334155;\n    white-space: nowrap;\n    flex: 0 0 auto;\n}\n\n.analysis-storage-row .asr-remove-btn {\n    flex: 0 0 auto;\n    background-color: #dc2626;\n    color: #fff;\n    border: none;\n    padding: 8px 14px;\n    border-radius: 4px;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.analysis-storage-row .asr-remove-btn:hover {\n    background-color: #b91c1c;\n}\n\n.analysis-storage-row .asr-remove-btn:disabled {\n    background-color: #cbd5e1;\n    cursor: not-allowed;\n}\n\n/* =========================\n   SAFE OVERRIDES ONLY\n========================= */\n\n/* Ensure container exists and is centered */\n.analyses-container {\n  width: 85% !important;\n  margin: 40px auto !important;\n}\n\n/* Strong row demarcation */\n.job-summary-table tbody tr {\n  border-bottom: 2px solid #e5e7eb !important;\n}\n\n/* Normalize ALL action buttons */\n.view-details-button,\n.log-button,\n.results-toggle-button,\n.report-toggle-button, \n.interpretation-button,\n.launch-jupyter-button {\n    min-width: 140px;\n    height: 38px;\n    font-size: 14px;\n    border-radius: 6px;\n    margin-right: 12px;\n    cursor: pointer;\n    font-weight: bold;\n    border: none;\n}\n\n\n/* Explicitly style log button (this WAS missing before) */\n/* 🔧 HARD RESET for Log button — remove embossed look */\n.log-button {\n  box-shadow: none !important;\n  border: none !important;\n  outline: none !important;\n  appearance: none;\n  -webkit-appearance: none;\n  background-image: none !important;\n  background: #6981ae;\n  color:#fffefe\n}\n\n/* Optional: consistent press behavior */\n.log-button:active {\n  transform: translateY(1px);\n  box-shadow: none !important;\n}\n\n\n.log-button:hover {\n  background: #1f2937;\n}\n\n.html-report {\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    border: 1px solid #ddd;\n    margin-bottom: 30px;\n    overflow-x: auto;\n}\n\n.interpretation-container {\n    margin-top: 40px;\n    padding: 20px;\n    background: #fafafa;\n    border-radius: 8px;\n}\n\n.download-selected-button {\n    float: right;\n    background: #213a22;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: bold;\n}\n\n.interpretation-button {\n    background-color: #273d3b;\n    color: #ddd;\n}\n\n.interpretation-button:hover {\n    background-color: #2f4f4d;\n}\n\n.interpret-button:disabled {\n    background-color: #999;\n    cursor: not-allowed;\n}\n\n.spinner {\n    width: 16px;\n    height: 16px;\n    border: 3px solid #fff;\n    border-top: 3px solid transparent;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n    margin: auto;\n}\n\n@keyframes spin {\n    to { transform: rotate(360deg); }\n}\n\n/* \"Pending\" indicator in the Credits Charged column (light cell background). */\n.charge-pending {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    color: #6b7280;\n    font-size: 13px;\n    font-style: italic;\n}\n.charge-pending-spinner {\n    width: 12px;\n    height: 12px;\n    border: 2px solid #cbd5e1;\n    border-top: 2px solid #2563eb;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n    flex: 0 0 auto;\n}\n\n.interpret-modal-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0,0,0,0.5);\n    z-index: 9999;\n}\n\n.interpret-modal {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: white;\n    padding: 24px;\n    border-radius: 8px;\n    width: 500px;\n    z-index: 10000;\n}\n\n.interpretation-button{\n    background-color: #273d3b;\n    border: none;\n    color:#ddd\n}\n\n.launch-jupyter-button {\n    background-color: #272a3d; /* deep indigo */\n    color: #ddd;\n}\n\n.launch-jupyter-button:hover {\n    background-color: #323657;\n}\n\n.loading-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0,0,0,0.4);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n}\n\n.spinner {\n    width: 60px;\n    height: 60px;\n    border: 8px solid #ccc;\n    border-top-color: #ff9800;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    to { transform: rotate(360deg); }\n}\n\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0,0,0,0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.modal {\n  background: white;\n  padding: 30px 40px;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.3);\n  text-align: center;\n  max-width: 400px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #ff9800; /* your CloudGenomics accent */\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin: 0 auto 20px auto;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Compact icon buttons in the execution \"Action\" column (labels moved to tooltips). */\n.icon-action {\n  box-sizing: border-box;\n  width: 40px !important;\n  height: 32px !important;\n  min-width: 40px !important;\n  max-width: 40px !important;\n  padding: 0 !important;\n  margin: 0 3px !important;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n  vertical-align: middle;\n}\n.icon-action:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* ---- Merged execution table: run name + inline run details, status icons, size ---- */\n.analysis-table td.run-cell { min-width: 240px; vertical-align: top; }\n\n.analysis-table th.col-credits,\n.analysis-table td.col-credits { width: 72px; text-align: right; white-space: nowrap; }\n\n.run-name { font-weight: 600; color: #213a22; word-break: break-all; }\n\n.run-details-toggle {\n  margin-top: 4px;\n  background: none;\n  border: none;\n  padding: 0;\n  color: #2563eb;\n  font-size: 12px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n.run-details-toggle:hover { text-decoration: underline; }\n.run-details-caret { display: inline-block; font-size: 9px; transition: transform 0.15s ease; }\n.run-details-caret.open { transform: rotate(90deg); }\n\n.run-details {\n  margin-top: 6px;\n  padding: 8px 10px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #475569;\n  line-height: 1.6;\n}\n.run-details .rd-label { font-weight: 600; color: #334155; }\n\n.status-cell { display: inline-flex; align-items: center; gap: 6px; white-space: nowrap; }\n.status-icon { font-size: 13px; line-height: 1; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
